import { useEffect, useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  Plus,
  Trash3Fill,
} from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import { BsListTask } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import GetSvgIcon from "../../../assets/images/svgList";
import FormButton from "../../../Components/Buttons/FormButton";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import TextAreaInput from "../../../Components/FormTag/TextAreaInput";
import DynamicAddEditGrid from "../../../Components/Grid/DynamicAddEditGrid";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import CommonModal from "../../../Components/Modals/CommonModal";
import SweetAlertComponent from "../../../Components/SweetAlertComponent";
import Table from "../../../Components/Tables/Table";
import useEventSystem from "../../../events/useEventSystem";
import BillToCodeLayout from "../../../Layout/BillToCodeLayout";
import PageHeader from "../../../Layout/PageHeader";
import { ApiResponse, SelcetOption } from "../../../model/common/apiResponse";
import { lookUpService } from "../../../Services/common/lookup.service";
import useClientStore from "../../../store/client/useClientStore";
import { useSearchStore } from "../../../store/search/searchStore";
import { useStore } from "../../../store/Store";
import { LookupInterface } from "../../CompanyAccount/model/accountForm.model";
import OverlayMessage from "../../Inventory/Overview/OverlayMessage";
import { CreateOrder, CustomerShipTo, deafultOrderValue, Order, OrderLookup, ServiceLevelLookup, ShipToLookup } from "./model/order.model";
import { orderEntry } from "./Order.type";
import { deleteOrderLineItem, getByOrderIdForEdit, submitOrderForm, updateOrderForm } from "./service/orderOverview.service";
import Loader from "../../../Components/GlobalLoader/Loader";
import { getcustomerShiptoById } from "../../Customer/service/customer.service";
import { CustomerBillTo } from "../../Customer/CustomerBillTo.type";
import { CONTACT_PHONE_PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import { CONTACT_NUM } from "../../../Shared/Helper/Constant";
import { formatNumber, formatPhoneNumber } from "../../../Utility/Utility";
import OutboundOrderAddLineLayout from "../../../Layout/OutboundOrderAddLineLayout";

interface OrderEntryProps {
  orderEntryT?: orderEntry;
  setOrderEntry?: (data: orderEntry) => void;
  billToCodeListO?: LookupInterface[];
}
export default function OrderAddEdit(props: OrderEntryProps) {
  const { id } = useParams();
  const [collapseStates, setCollapseStates] = useState<boolean[]>([true]);
  const [data, setData] = useState<any[]>([]);
  const [handleInput, setHandleInput] = useState<string>("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const { setSearchTerm, resetSearch } = useSearchStore();
  const [showAddLineModal, setShowAddLineModal] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [show, setShow] = useState(false);
  const [clientData, setClientData] = useState<any>(null);
  const resetSelectedItems = useStore((state) => state.resetSelectedItems);
  const navigation = useNavigate();
  const [createOrderData, setCreateOrderData] = useState<CreateOrder>(deafultOrderValue);
  const [loading, setLoading] = useState(true); // Add loading state
  const [lookupData, setLookupData] = useState<OrderLookup>({ customer: [], carrier: [], country: [] });
  const [shipToLookup, setShipToLookup] = useState<ShipToLookup>({ shipTo: [] });
  const [serviceLevelLookup, setServiceLevelLookup] = useState<ServiceLevelLookup>({ serviceLevel: [] });
  const { getSelectedClient } = useClientStore();
  const { emit } = useEventSystem();
  const [overlayMessage, setOverlayMessage] = useState("");
  const [isClientSelected, setIsClientSelected] = useState(false);
  const [showDeleteConfModal, setShowDeleteConfModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<{ item: any, index: number } | null>(null);
  const [billTos, setBillTos] = useState<CustomerBillTo[] | null> (null);
  const [billToDeatils, setBillToDeatils] = useState<CustomerBillTo | null> (null);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const setSelectedItem = useStore((state) => state.setSelectedItem);
  const selectedItem = useStore((state) => state.selectedItem || []);
  useEffect(() => {
    setLoading(true);
    setSelectedItem([]);
    resetSelectedItems();
    resetSearch();
    setCollapseStates((prev) => prev.map(() => true));
    
    // First fetch common data
    fetchData().then(async () => {
      // Then fetch order details if in edit mode
      if (id) {
        try {
          const response = await getByOrderIdForEdit(id);
          const data = response?.data as Order;
          
          if(data.customer?.id){
            await fetchShipTosList(data.customer?.id);
          }
          
          setCreateOrderData({
            customer: data?.customer?.code?.toString(),
            order_number: data.order_number ?? "",
            customer_bill_to: data?.customer_bill_to?.code?.toString(),
            customer_ship_to: data?.customer_ship_to?.code?.toString(),
            ship_to_name: data?.customer_ship_to?.name,
            address_line_1: data?.address_line_1,
            address_line_2: data?.address_line_2,
            city: data?.city,
            state_province: data?.state_province,
            postal_code: data?.postal_code,
            country: data?.country?.code ?? "",
            order_date: data?.order_date ? new Date(data.order_date).toISOString().split('T')[0] : '',
            ship_by_date: data?.ship_by_date ? new Date(data.ship_by_date).toISOString().split('T')[0] : '',
            contact_name: data?.contact_name,
            contact_phone: data?.contact_phone,
            carrier: "",
            serviceLevel: "",
            customer_po_number: data?.customer_po_number ?? "",
            customer_order_number: data?.customer_order_number ?? "",
            notes_1: data?.notes_1,
            special_instructions: data?.special_instructions,
            lines: []
          });

             // Set client data
            if (
              data?.client &&
              data.client.id &&
              data.client.code &&
              data.client.name
            ) {
              const clientData = {
                id: data.client.id,
                code: data.client.code,
                name: data.client.name,
                is_active: data.client.is_active ?? 1,
              };
              setClientData(clientData);
              useClientStore.getState().onchangeClient(clientData);
            }
            
          // Map the line items from the response to the selected items format
          const mappedLines = data?.lines?.map((line: any) => ({
            id: line.id,
            order_id: data.id,
            code: line?.item?.code,
            description: line?.item?.description,
            uom_code: line?.uom_code,
            ExpectedQty: line?.qty_ordered?.toString(),
            Line: line?.line_number?.toString(),
            item: {
              id: line?.item?.id,
              code: line?.item?.code
            }
          })) || [];
          console.log("Before Lines set",selectedItem);
          setSelectedItem(mappedLines);
          console.log("After Lines set",selectedItem);
        } catch (error) {
          console.error("Error fetching order details:", error);
          toast.error("Failed to load order details");
        }
      }

    }).finally(() => {
      setLoading(false);
    });
  }, [id]);

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const [showBillCode, setShowBillCode] = useState(false);
  const handleShowBillCode = () => {
    setShowBillCode(true);
  };
  const handleCloseBillCode = () => {
    setShowBillCode(false);
  };
  // Move useForm before data fetching
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    control,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<CreateOrder>({
    defaultValues: deafultOrderValue,
    mode: "onChange",
  });

  // Add effect to update form when createOrderData changes
  useEffect(() => {
    if (createOrderData) {
      reset(createOrderData);
    }
  }, [createOrderData, reset, setValue]);
  const handleSelectCustomerChange = async (customer: any) => {
    reset({ ...deafultOrderValue, customer: customer.value,order_date:getValues("order_date"),ship_by_date:getValues("ship_by_date"),contact_name:getValues("contact_name"),contact_phone:getValues("contact_phone"),customer_order_number:getValues("customer_order_number"),customer_po_number:getValues("customer_po_number"),notes_1:getValues("notes_1"),special_instructions:getValues("special_instructions") });
    setLoading(true);
    await fetchShipTosList(customer?.id);
  }
  const fetchShipTosList=async(customer_id:any)=>{
    await fetchShipToCode(customer_id).finally(() => {
      setLoading(false);
    })
  }
  const handleSelectShipToChange = async (shipTo: CustomerShipTo) => {
    setLoading(true);
    await getcustomerShiptoById(shipTo.id).then((response) => {
      setValue('ship_to_name',response?.data?.name)
      setValue('address_line_1',response?.data?.address_line_1)
      setValue('address_line_2',response?.data?.address_line_2)
      setValue('city',response?.data?.city)
      setValue('state_province',response?.data?.state_province)
      setValue('postal_code',response?.data?.postal_code)
      setValue('country',response?.data?.country?.code)
      setValue('contact_name',response?.data?.contact_name)
      const contactPhone = response?.data?.contact_phone;
      if (contactPhone) {
        const formattedNumber = formatPhoneNumber(contactPhone);
        setValue('contact_phone', formattedNumber);
      } else {
        setValue('contact_phone', '');
      }
    }).finally(() => {
      setLoading(false);
    })  
  }

  const handleSelectBillToData = async (customer: { id: string }) => {
    if (!Object.keys(customer)) return; 
  
    try {
      setLoading(true);
      await findBilltoDetails(customer?.id)

    } catch (error) {
      console.error('Failed to fetch bill-to details:', error);
    } finally {
      setLoading(false);
    }
  };
 const findBilltoDetails=async(id:string)=>{
      if(billTos && id){
        const billToDetails= billTos.find((item)=> item.id===parseInt(id));
        setBillToDeatils(billToDetails?? null);
      }else{
        return
      }
     
  }

  const handleSelectCarrierChange = async (carrier: any) => {
    setLoading(true);
    await fetchServiceLevel().finally(() => {
      setLoading(false);
    });
  }
  const fetchData = async () => {
    try {
      const customerResponse = await lookUpService.customerLookup();

      const carriersResponse = await lookUpService.carriersLookup();
      const countryResponse = await lookUpService.countryLookup();
      setBillTos(customerResponse.data?.data?.results?? []);
      const customerData: SelcetOption[] =
        customerResponse.data?.data?.results.map((obj: any) => ({
          label: `${obj.name}(${obj.code})`,
          value: obj.code,
          id: obj.id,
        }));

      const carrierData: SelcetOption[] =
        carriersResponse.data?.data?.results.map((obj: any) => ({
          label: obj.name,
          value: obj.code,
          code: obj.code,
        }));

      const countryData: SelcetOption[] =
        countryResponse.data?.data?.map((obj: any) => ({
          label: obj.name,
          value: obj.code,
          code: obj.code,
        }));
      setLookupData({
        customer: customerData,
        carrier: carrierData,
        country: countryData,
      });
      resetForm();
    } catch (error) {
    }
  };
  const resetForm = () => {
    if (id) return;
    reset(deafultOrderValue);
    resetSelectedItems();
  }

  const fetchShipToCode = async (customer_id: string) => {
    const shipToResponse = await lookUpService.shipToLookup(customer_id);

    const shipToData: SelcetOption[] =
      shipToResponse.data?.data?.results.map((obj: any) => {
        return {
          label: `${obj.name}(${obj.code})`,
          value: obj.code,
          id: obj.id,
        };
      });

    setShipToLookup({
      shipTo: shipToData
    });
    return shipToResponse.data?.data?.results;
  }

  const fetchServiceLevel = async () => {
    const ServiceLevelResponse = await lookUpService.carriersLookup();

    const ServiceLevelData: SelcetOption[] =
    ServiceLevelResponse.data?.data?.results.map((obj: any) => {
        return {
          label: obj.name,
          value: obj.code,
          id: obj.id,
        };
      });

    setServiceLevelLookup({
      serviceLevel: ServiceLevelData
    });
    return ServiceLevelResponse.data?.data?.results;
  }

  const itemsDataParser = () => {
    return selectedItem.map((item: any) => ({
      ...(item.id && { id: item.id }),
      item: {
        id: item.item?.id || parseInt(item.id),
        code: item.item?.code || item.code
      },
      line_number: parseInt(item.Line || '0'),
      qty_ordered: parseInt(item.ExpectedQty),
      uom_code: item.uom_code || "EA",
      unit_price: parseFloat(item.unit_price) || null,
      customer_item_code: item.customer_item_code || null,
      customer_line_number: item.customer_line_number || null
    }));
  };
  const getCode = (value: string, sourceArray: any[]) => {
    const foundItem = sourceArray.find(
      (item: any) => parseInt(item.value) === parseInt(value)
    );
    return foundItem?.code ?? "";
  };
  useEffect(() => {
    const subscription = getSelectedClient().subscribe((client) => {
      setClientData(client);
      if (client && client.code!=='all') {
        emit('show_client_warning', false);
        setOverlayMessage("");
        setIsClientSelected(true);
      } else {
        emit('show_client_warning', true);
        setIsClientSelected(false);
        setOverlayMessage("Please select a Client");
      }
    });
    return () => subscription.unsubscribe();
  }, [getSelectedClient]);

  const getClientData = async () => {
    if (clientData && Object.keys(clientData).length > 0 && clientData.code!=='all') {
      return clientData;
    } else {
      toast.error("Client code is required!", { duration: 2000 });
      setSubmitting(false);
    }
  };

  const nextData: SubmitHandler<CreateOrder> = async (formData) => {
    setIsFormSubmit(true);
    await getClientData();
    if (!clientData?.id || !clientData?.code || clientData.code==='all') {
      setSubmitting(false);
      return;
    }

    if (submitting) return;
    setSubmitting(false);
    let requestPayload: any = { ...formData, client: { code: clientData.code } };
    if (requestPayload.customer) {
      requestPayload.customer = {
        "code": requestPayload.customer
      }
    }
    if (requestPayload.customer_bill_to) {
      requestPayload.customer_bill_to = {
        "code": requestPayload.customer_bill_to
      }
    }
    if (requestPayload.customer_ship_to) {
      requestPayload.customer_ship_to = {
        "code": requestPayload.customer_ship_to
      }
    }
    if (requestPayload.carrier) {
      requestPayload.carrier = {
        "code": requestPayload.carrier
      }
    }
    if (requestPayload.serviceLevel) {
      requestPayload.serviceLevel = {
        "code": requestPayload.serviceLevel
      }
    }
    if (requestPayload?.country) {
      requestPayload.country = {
        "code": requestPayload.country
      }
    }
    else{
      delete requestPayload.country
    }
    requestPayload.lines = itemsDataParser();

    try {
      let response: ApiResponse<any>;
      if (id) {
        response = await updateOrderForm(requestPayload, id);
      }
      else {
        response = await submitOrderForm(requestPayload);
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(id ? "Order updated successfully!" : "Order created successfully!", { duration: 5000 });
        resetSelectedItems();
        resetSearch();
        setTimeout(() => {
          navigation("/outbound/orders");
        }, 1000)
      } else {
        toast.error(id ? "An error occurred while updating Order." : "An error occurred while creating Order.", {
          duration: 2000,
        });
        setSubmitting(false);
      }
      setIsFormSubmit(false);
    } catch (error) {
      toast.error(id ? "An error occurred while updating Order." : "An error occurred while creating Order.", {
        duration: 2000,
      });
      setSubmitting(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleAlertButtonClick = () => {
    navigate(`/outbound/orders`);
  }
  const handleSubmitOrder = () => {
    triggerSweetAlert("Your <b>Order #612332323</b> is created successfully", GetSvgIcon.ScannerSuccessLogo, "<b>Order Confirm</b>");
  }
  const triggerSweetAlert = (message: string, logo: any, header: string) => {
    SweetAlertComponent.showAlert({
      logo: logo,
      text: message,
      buttonText: "Ok",
      onButtonClick: handleAlertButtonClick,
      header: header
    });
  };
  const handleItemSelect = (item: Record<string, any>) => {
    if (selectedItem) {
      item.Line = (selectedItem.length + 1).toString();
      setSelectedItem([...selectedItem, item]);
    } else {
      setSelectedItem(data);
    }
  };
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };


  const handleCancelBtn = () => {
    resetSelectedItems();
    resetSearch();
    navigation("/outbound/orders");
  };
  const validateAndClearErrors = async (fieldName: keyof CreateOrder) => {
    const isValid = await trigger(fieldName);

    if (isValid) {
      clearErrors(fieldName);
    }
  };
  const navigate = useNavigate();

  const orderentryEditJSON = "outboundOrderEdit.json";
  // useEffect(() => {
  //   const orderEntryInstance = new orderEntry();
  //   fetchData(orderentryEditJSON).then((response) => {
  //     const data = transformData([orderEntryInstance], response);
  //     setTransformedData(data.orderEntry);
  //   });
  // }, []);

  const OrderEntryData = {
    OrderEntryDetailsExpanded: [
      {
        label: (
          <>
          Customer Code <span style={{ color: 'red' }}>*</span>
          </>
        ), 
        value: (
          <>
            <div className="dropdown-container">
              <FormSelect
                tabIndex={4}
                name="customer"
                control={control}
                optionList={lookupData.customer ?? []}
                className="form-control p-0"
                placeholder="Select"
                isSearchable={true}
                selectedOption={handleSelectCustomerChange}
                required
              />
              <div className="dropdown-icon"></div>
            </div>
          </>
        ),
      },
      {
        label: (
          <>
          Bill-to Code <span style={{ color: 'red' }}>*</span>
          </>
        ),
        value: (
         
            <div className="dropdown-container">
              <FormSelect
                tabIndex={4}
                name="customer_bill_to"
                control={control}
                optionList={lookupData.customer ?? []}
                className="form-control p-0"
                placeholder="Select"
                isSearchable={true}
                required
                selectedOption={handleSelectBillToData}
              />
              <div className="dropdown-icon">
                {(getValues("customer_bill_to")) ? 
                <BsListTask
                className="cursor-pointer"
                onClick={handleShowBillCode}
               /> : null
                
              }
              </div>
            </div>
         
        ),
      },
      {
        label: (
          <>
          Ship-to Code <span style={{ color: 'red' }}>*</span>
          </>
        ),
        value: (
          <>
            <div>
              <FormSelect
                tabIndex={4}
                name="customer_ship_to"
                control={control}
                optionList={shipToLookup.shipTo ?? []}
                className="form-control p-0"
                placeholder="Select"
                isSearchable={true}
                selectedOption={handleSelectShipToChange}
                required
                disabled = {(getValues("customer"))? false:true}
              />
            </div>
          </>
        ),
      },
      {
        label: "Ship-to Name",
        value: (
      
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="ship_to_name"
              className={`form-control`}
              placeholder="Enter Ship-to Name"
              register={register}
            />
        
        ),
      },
      {
        label: "Address 1",
        value: (
         
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="address_line_1"
              className={`form-control`}
              placeholder="Enter Address 1"
              register={register}
            />
      
        ),
      },
      {
        label: "Address 2",
        value: (
         
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="address_line_2"
              className={`form-control`}
              placeholder="Enter Address 2"
              register={register}
            />
         
        ),
      },
      {
        label: "City",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="city"
              className={`form-control`}
              placeholder="Enter City"
              register={register}
            />
          </>
        ),
      },
      {
        label: "State",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="state_province"
              className={`form-control`}
              placeholder="Enter State"
              register={register}
            />
          </>
        ),
      },
      {
        label: "Zip/Postal Code",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="postal_code"
              className={`form-control`}
              placeholder="Enter Zip"
              register={register}
            />
          </>
        ),
      },
      {
        label: "Country",
        value: (
          <FormSelect
            tabIndex={4}
            name="country"
            control={control}
            optionList={lookupData.country ?? []}
            className="form-control p-0"
            placeholder="Select Country"
            isSearchable={true}
          />
        ),
      },
    ],

    OrderEntryDetailsDefault: [
      { label: "Bill-to Code", value: getValues("customer_bill_to") },
      { label: "Ship-to Code", value: getValues("customer_ship_to") }
    ],
  };
  const OrderEntryDetailsData2 = {
    OrderEntryDetailsExpanded2: [
      {
        label: "Order Date",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="date"
              name="order_date"
              className={`form-control`}
              register={register}
            />
          </>
        ),
      },
      {
        label: "Ship-by Date",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="date"
              name="ship_by_date"
              className={`form-control`}
              register={register}
            />
          </>
        ),
      },
      {
        label: "Contact Name",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="contact_name"
              className={`form-control`}
              placeholder="Enter Name"
              register={register}
            />
          </>
        ),
      },
      {
        label: "Contact Number",
        value: (
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="contact_phone"
              className={`form-control`}
              placeholder="Enter Contact Number"
              register={register}
              pattern={{
                type: CONTACT_NUM,
                message: CONTACT_PHONE_PATTERN_ERR_MSG,
              }}
              errors={errors.contact_phone}
              onChange={async (e: any) => {
                const formattedNumber = formatPhoneNumber(e.target.value);
                setValue("contact_phone", formattedNumber);
                await validateAndClearErrors("contact_phone");
              }}
            />
        ),
      },
      {
        label: "Carrier",
        value: (
          <FormSelect
            tabIndex={4}
            name="carrier"
            control={control}
            optionList={lookupData.carrier ?? []}
            className="form-control p-0"
            isSearchable={true}
            selectedOption={handleSelectCarrierChange}
          />
        ),
      },
      {
        label: "Service Level",
        value: (
          <FormSelect
            tabIndex={4}
            name="serviceLevel"
            control={control}
            optionList={lookupData.carrier ?? []}
            className="form-control p-0"
            isSearchable={true}
            disabled = {(getValues("carrier"))? false:true}
          />
        ),
      },
      {
        label: "Customer Sales Order",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="customer_order_number"
              className={`form-control`}
              placeholder="Enter Customer Sales Order"
              register={register}
            />
          </>
        ),
      },
      {
        label: "Customer Purchase Order",
        value: (
          <>
            <InputFiled
              tabIndex={1}
              maxLength={50}
              type="text"
              name="customer_po_number"
              className={`form-control`}
              placeholder="Enter Customer Purchase Order"
              register={register}
            />
          </>
        ),
      },
      {
        label: "Notes",
        value: (
          <TextAreaInput
            tabIndex={1}
            name="notes_1"
            className={`form-control`}
            placeholder="Enter Text Here"
            register={register}
          />
        ),
      },
      {
        label: "Special Instructions",
        value: (
          <TextAreaInput
            tabIndex={1}
            name="special_instructions"
            className={`form-control`}
            placeholder="Enter Text Here"
            register={register}
          />
        ),
      },
    ],

    OrderEntryDetailsDefault2: [
      { label: "Order Date", value: getValues("order_date") },
      { label: "Ship-by Date", value: getValues("ship_by_date") }
    ],
  };

  const columns = [
    {
      name: "Line #",
      cell: (row: any, index: number) => <div>{row.code ? index + 1 : ""}</div>,
      width: "80px"
    },
    {
      name: "Item Code",
      cell: (row: any) =>
        selectedItem.some((selectedRow) => selectedRow.code === row.code) ? (
          <div>{row.code}</div>
        ) : (
          <>
            <div className="input-group rounded-pill col-auto w-100">
              <input
                type="text"
                placeholder="Search"
                className="form-control border border-end-0 pe-0 search-input"
                value={handleInput}
                onChange={handleInputChange}
                onKeyDown={handleEnterPress}
              />
              <span
                className="input-group-text bg-white border border-start-0 rounded-end-pill cursor-pointer"
                onClick={handleSearchTerm}
              >
                {GetSvgIcon.GlobalSearchIcon}
              </span>
            </div>
          </>
        ),
      width: "180px"
    },
    {
      name: "Item Name",
      cell: (row: any) => <div>{row.name}</div>,
      width: "200px"
    },
    {
      name: "UOM",
      cell: (row: any) => <div>{row.uom_code}</div>,
      width: "100px"
    },
    {
      name: "Ordered Qty",
      cell: (row: any) => <div>{formatNumber(row.ExpectedQty)}</div>,
      width: "120px"
    },
    {
      name: "",
      cell: (row: any, index: number) =>
        row.id && (
          <Trash3Fill
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteConModal(row, index);
            }}
          />
        ),
      width: "50px"
    },
  ];

  const blankRow = {};

  const handleItemAddition = (selectedRows: any[]) => {
    if (selectedItem) {
      let lastLineNumber = selectedItem.length;
      const newItems = selectedRows.map((item) => ({
        id: item.id,
        code: item.code,
        name: item.name,
        uom_code: item.uom_code,
        qty_on_hand: item.qty_on_hand,
        ExpectedQty: item.ExpectedQty,
        Line: (++lastLineNumber).toString(),
        cost: item.cost,
        supplier_item_code: item.supplier_item_code
      }));
      setSelectedItem([...selectedItem, ...newItems]);
    }
  };

  const handelSelectRows = (selectedRow: Set<number>) => {
    setSelectedRowsCount(selectedRow.size);
  };
  const handleOverlayClose = () => {
    emit('show_client_warning', false);
    return navigation(`/outbound/orders`);
  }

  // Add these handlers for line item deletion
  const handleDeleteConModal = (row: any, index: number) => {
    setItemToDelete({ item: row, index });
    if (id) {
      setShowDeleteConfModal(true);
    } else {
      handleLineItemDelete();
    }
  };

  const handleLineItemDelete = () => {
    if (itemToDelete) {
      const updatedItems = [...selectedItem];
      updatedItems.splice(itemToDelete.index, 1);
      // Reorder line numbers
      const reorderedItems = updatedItems.map((item, index) => ({
        ...item,
        Line: (index + 1).toString(),
      }));
      setSelectedItem(reorderedItems);
      setItemToDelete(null);
    }
  };

  // Add this function to handle delete confirmation for edit mode
  // You'll need to implement/import deleteLineItem service
  const handleConfirmDeleteForEdit = (isAccepted: boolean) => {
    if (!isAccepted) {
      setShowDeleteConfModal(false);
      return;
    }
    if (itemToDelete && id && isAccepted) {
      if (!itemToDelete.item.order_id) {
        handleLineItemDelete();
        setShowDeleteConfModal(false);
        setItemToDelete(null);
        return;
      }
      deleteOrderLineItem(itemToDelete.item.order_id, itemToDelete.item.id).then((response) => {
        if (response.status === 200) {
          handleLineItemDelete();
          toast.success("Order Line item deleted successfully!", { duration: 2000 });
        } else {
          toast.error("Failed to delete line item!", { duration: 2000 });
        }
        setShowDeleteConfModal(false);
        setItemToDelete(null);
      })
      handleLineItemDelete();
      setShowDeleteConfModal(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setHandleInput(value);
    setSearchInputValue(value);
  };

  const handleSearchTerm = () => {
    setSearchTerm(handleInput);
    setShowAddLineModal(true);
  };

  const handleEnterPress = (event: any) => {
    if (event.key === "Enter") {
      handleSearchTerm();
    }
  };

  return !loading ? (
    <>
      <Toaster />
      {!isClientSelected ?
        <OverlayMessage message={overlayMessage} onClose={handleOverlayClose} /> :
        <PageHeader
          addUrl="/outbound/orders/add"
          listUrl="/outbound/orders"
          viewType={true}
          isHistoryEnabled={true}
          nameButtonStatus={selectedRowsCount > 0}
        />
      }
      {/* <PageHeader
        listUrl="/outbound/orders"
        viewType={true}
        isHistoryEnabled={true}
        nameButtonStatus={selectedRowsCount > 0}
      /> */}
      <h5 className="text-start mt-1 mb-3">
        {id ? `Edit Order(${id})` : "Create Order"}
      </h5>

      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2">
          {collapseStates[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white">
              <DynamicAddEditGrid
                customClassName="my-2 col border-end"
                isExpandable={false}
                columns={2}
                data={OrderEntryData.OrderEntryDetailsExpanded}
              />
              <DynamicAddEditGrid
                customClassName="my-2 col custom-dynamic-grid-height"
                isExpandable={false}
                columns={2}
                data={OrderEntryDetailsData2.OrderEntryDetailsExpanded2}
              />

              <div className="col-1">
                <div className="align-self-center d-flex flex-row-reverse my-4">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="checkin-details row align-items-top d-flex bg-white">
              <DynamicAddEditGrid
                customClassName="my-2 col border-end"
                isExpandable={false}
                columns={2}
                data={OrderEntryData.OrderEntryDetailsDefault}
              />
              <DynamicAddEditGrid
                customClassName="my-2 col custom-dynamic-grid-height"
                isExpandable={false}
                columns={2}
                data={OrderEntryDetailsData2.OrderEntryDetailsDefault2}
              />
              <div className="col-1">
                <div className="align-self-center d-flex flex-row-reverse my-4">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mb-2 bg-white rounded py-1 px-4 d-flex flex-column h-100">
        <Table
          data={[...selectedItem, blankRow]}
          columns={columns}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />

        <div className="d-flex align-items-center mt-auto mb-2">
          <div
            onClick={() => setShowAddLineModal(true)}
            className="d-flex align-items-center"
          >
            <div className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center">
              <Plus />
            </div>
            <small className="cursor-pointer fw-bold mb-2">Add Line</small>
          </div>

          <CommonModal
            customClassName="header-border"
            modalSize="modal-xl"
            customClassNameForBody="line-item-modal-height"
            handleClose={() => {
              setShowAddLineModal(false);
              setHandleInput("");
              setSearchInputValue("");
              setSearchTerm("");
            }}
            show={showAddLineModal}
            heading="Add Line Items"
            backdrop={false}
            content={
              <OutboundOrderAddLineLayout
                clientId={clientData?.id}
                data={[]}
                handleClose={() => {
                  setShowAddLineModal(false);
                  setHandleInput("");
                  setSearchInputValue("");
                  setSearchTerm("");
                }}
                handleAddItem={handleItemAddition}
                initialSearchTerm={searchInputValue}
              />
            }
          />
        </div>
      </div>

      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
          disabled={isFormSubmit}
            tabIndex={11}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
          >
           {id? 'Update': 'Submit'} 
          </FormButton>

          <FormButton
            className="sph-btn sph-shift me-2"
            handleClick={handleCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>

      <CommonModal
        modalSize="modal-md"
        customClassnameForHr="hr-billing-info"
        handleClose={handleCloseBillCode}
        show={showBillCode}
        heading="Billing Info"
        content={<BillToCodeLayout 
          customer= {billToDeatils ?? null}
          />}
      />

      <CommonConfirmationModal
        confirmBtnText="Delete"
        cancelBtnText="Cancel"
        onModalSubmit={handleConfirmDeleteForEdit}
        title="Delete Line Item"
        content={"Are you sure you want to delete this line item?"}
        show={showDeleteConfModal}
      />
    </>
  ) : <Loader />;
}
